import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import {
  EuiSpacer,
  EuiButton,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
} from "@elastic/eui";

export default function WebUIArticles() {
  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Fotoserie/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Tasks_Snapshot_Schedule.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Aufnahme Menu - Fotoserie"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Fotoserie"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Fotoserie/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Video/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Tasks_Video_Recording.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Aufnahme Menu - Video"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Video"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Video/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Snapshot_Zeitplan/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Tasks_Photoseries.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Aufnahme Menu - Snapshot Zeitplan"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Snapshot Zeitplan"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Snapshot_Zeitplan/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Position_Zeitplan/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Tasks_Position_Schedule.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Aufnahme Menu - Position Zeitplan"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Position Zeitplan"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Position_Zeitplan/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Relais_Zeitplan/">
                  <StaticImage
                    src="../../../../images/Search/WebUI_1440p_SearchThumb_Tasks_Relay_Schedule.webp"
                    alt="INSTAR UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface Aufnahme Menu - Relais Zeitplan"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Relais Zeitplan"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Relais_Zeitplan/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem></EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
